import { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';

import { PromoteSbcModal } from '../promote-sbc-modal';

const STORAGE_KEY = 'persist:is-reward-sbc-modal-shown';

export const PromoteSbcModalContainer = () => {
	const [isShow, setIsShow] = useState(false);

	const closeModal = () => {
		setIsShow(false);
	};

	useEffect(() => {
		const isModalShown = localStorage.getItem(STORAGE_KEY) === 'true';

		if (!isModalShown) {
			setIsShow(true);
			localStorage.setItem(STORAGE_KEY, 'true');
		}
	}, []);

	return isShow ? createPortal(
		<PromoteSbcModal onClose={closeModal} />,
		document.getElementById('shop-wrapper')!
	) : null;
};